import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LandingPortal from "../pages/landing/page";
import Dashboard from "../pages/dashboard/page";
import UserMemories from "../pages/user-memories/page";
import KnowledgeBase from "../pages/knowledge-base/page";
import CallLogs from "../pages/call-logs/page";
import OpenItems from "../pages/open-items/page";
import Team from "../pages/team/page";
import Integrations from "../pages/integrations/page";
import AISettings from "../pages/ai-settings/page";
import PhoneSystem from "../pages/phone-system/page";
import Login from "../pages/login/page";
import PricingPage from "../pages/pricing/page";
import Register from "../pages/register/page";
import PersonalityStudio from "../pages/personality-studio/page";
import Billing from "../pages/billing/page";
import PhoneSystemApp from "../pages/phone-system-app/page";
import Transfer from "../pages/transfer/page";
import RequireAuth from "../components/RequireAuth";
import SetupPage from "../pages/setup/page";

import OnboardingStep1 from "../pages/onboarding/step1";
import OnboardingStep2 from "../pages/onboarding/step2";
import OnboardingStep3 from "../pages/onboarding/step3";
import OnboardingStep4 from "../pages/onboarding/step4";
import OnboardingCheckout from "../pages/onboarding/checkout";
import OnboardingSuccess from "../pages/onboarding/success";
import ChooseNumber from "../pages/onboarding/choose-number";
import CallerMemory from "../pages/features/caller-memory";
import AnswersEveryCall from "../pages/features/answers-every-call";
import BooksAnswersTransfers from "../pages/features/books-answers-transfers";
import TrialPage from "../pages/trial/page";
import InsurancePage from "../pages/insurance/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <RequireAuth><Dashboard /></RequireAuth>,
  },
  {
    path: "/ai-settings",
    element: <RequireAuth><AISettings /></RequireAuth>,
  },
  {
    path: "/phone-system",
    element: <PhoneSystem />,
  },
  {
    path: "/ai-voice-system",
    element: <Navigate to="/transfer" replace />,
  },
  {
    path: "/user-memories",
    element: <RequireAuth><UserMemories /></RequireAuth>,
  },
  {
    path: "/callers",
    element: <Navigate to="/user-memories" replace />,
  },
  {
    path: "/knowledge-base",
    element: <RequireAuth><KnowledgeBase /></RequireAuth>,
  },
  {
    path: "/open-items",
    element: <RequireAuth><OpenItems /></RequireAuth>,
  },
  {
    path: "/team",
    element: <RequireAuth><Team /></RequireAuth>,
  },
  {
    path: "/call-logs",
    element: <RequireAuth><CallLogs /></RequireAuth>,
  },
  {
    path: "/integrations",
    element: <RequireAuth><Integrations /></RequireAuth>,
  },
  {
    path: "/personality-studio",
    element: <RequireAuth><PersonalityStudio /></RequireAuth>,
  },
  {
    path: "/home",
    element: <LandingPortal />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/features/caller-memory",
    element: <CallerMemory />,
  },
  {
    path: "/features/answers-every-call",
    element: <AnswersEveryCall />,
  },
  {
    path: "/features/books-answers-transfers",
    element: <BooksAnswersTransfers />,
  },
  {
    path: "/insurance",
    element: <InsurancePage />,
  },
  {
    path: "/trial",
    element: <TrialPage />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/onboarding",
    element: <OnboardingStep1 />,
  },
  {
    path: "/onboarding/1",
    element: <OnboardingStep1 />,
  },
  {
    path: "/onboarding/2",
    element: <OnboardingStep2 />,
  },
  {
    path: "/onboarding/3",
    element: <OnboardingStep3 />,
  },
  {
    path: "/onboarding/4",
    element: <OnboardingStep4 />,
  },
  {
    path: "/onboarding/checkout",
    element: <OnboardingCheckout />,
  },
  {
    path: "/onboarding/success",
    element: <OnboardingSuccess />,
  },
  {
    path: "/onboarding/choose-number",
    element: <ChooseNumber />,
  },
  {
    path: "/billing",
    element: <RequireAuth><Billing /></RequireAuth>,
  },
  {
    path: "/phone-system-app",
    element: <RequireAuth><PhoneSystemApp /></RequireAuth>,
  },
  {
    path: "/transfer",
    element: <RequireAuth><Transfer /></RequireAuth>,
  },
  {
    path: "/setup",
    element: <RequireAuth><SetupPage /></RequireAuth>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
